import React from "react";
import { Col } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

interface IPropsRegisterButton {
  id: string;
  title: string;
  dataTestId: string;
  onClick: (...args) => void;
  size?: string;
}

export const RegisterButton = ({ id, title, dataTestId, onClick, size = "220px" }: IPropsRegisterButton): JSX.Element => (
  <Col flex={size} style={S.AddButtonCol}>
    <S.AddButton id={id} data-testid={dataTestId} htmlType="submit" onClick={onClick} size={size}>
      {useTranslation({ id: title })}
    </S.AddButton>
  </Col>
);
